import { App } from 'antd';

export default function useAppMessage() {
  const { message } = App.useApp();
  return message;
}
